import type { CategoriesResponse } from '@atlassian/jira-servicedesk-knowledge-services/src/services/rest/categories';

export const FETCH_CATEGORIES_SUCCESS =
	'state.actions.fetch-categories-success.FETCH_CATEGORIES_SUCCESS' as const;

export type FetchCategoriesSuccessAction = {
	type: typeof FETCH_CATEGORIES_SUCCESS;
	payload: CategoriesResponse;
};

export const fetchCategoriesSuccess = (
	payload: CategoriesResponse,
): FetchCategoriesSuccessAction => ({
	type: FETCH_CATEGORIES_SUCCESS,
	payload,
});
